import { createSlice } from '@reduxjs/toolkit';
import { fetchBrands } from '../actions/brandActions';

const initialState = {
  brands: [],
  loading: false,
  error: null,
  status: 'idle',
};

const brandSlice = createSlice({
  name: 'brand',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrands.pending, (state) => {
        state.status = 'loading';
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrands.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.loading = false;
        state.brands = action.payload;
      })
      .addCase(fetchBrands.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearError } = brandSlice.actions;

// Selectors
export const selectBrands = (state) => state.brand.brands;
export const selectBrandsLoading = (state) => state.brand.loading;
export const selectBrandsError = (state) => state.brand.error;

export default brandSlice.reducer;
